import { State } from './types'

export const REDUX_STORE_HOME = 'article_activity'

export const InitialState: State = {
  checked: 0,
  csvKey: 0,
  csvMessage: '',
  data: [],
  error: '',
  headers: '',
  isChecking: false,
  isLoading: true,
  isSaving: false,
  mode: 'paste',
  names: {},
  saveFailed: 0,
  saveTotal: 0,
  saved: 0,
  selectedCommunity: '',
  success: false,
  summary: '',
  url: [],
}

// Urls per request to the bulk-source endpoints (server caps a request at 100).
export const CHUNK_SIZE = 10
// Requests in flight at once; feed discovery is slow, so keep this modest.
export const CONCURRENCY = 3

// Statuses returned by the server.
export const STATUS_FOUND = 'Feed found'
export const STATUS_ALREADY = 'Feed already exist'
export const STATUS_INVALID = 'Invalid feed'
// Statuses assigned by this page.
export const STATUS_PENDING = 'Checking...'
export const STATUS_CHECK_FAILED = 'Check failed'
export const STATUS_SAVED = 'Saved'
export const STATUS_SAVE_FAILED = 'Save failed'
